import type { ReactNode } from 'react';

interface Props {
  title?: string;
  description?: string;
  count?: string;
  children: ReactNode;
}

export default function WidgetCard({ title, description, count, children }: Props) {
  return (
    <div className="pi-widget-card">
      {title && (
        <div className="pi-widget-header">
          <div>
            <h3>{title}</h3>
            {description && <div className="description">{description}</div>}
          </div>
          {count && <span className="count-badge">✦ {count}</span>}
        </div>
      )}
      {children}
    </div>
  );
}
